import * as React from 'react';

import { IconCheckmark } from '@lightspeed/flame/Icon/Checkmark';
import { IconDanger } from '@lightspeed/flame/Icon/Danger';
import { IconWarning } from '@lightspeed/flame/Icon/Warning';

import { AlertMessageDTO } from 'root/apps/components/AlertMessageDisplay/AlertMessageDisplay';
import TooltipHelp from 'root/apps/Tooltip/components/TooltipHelp';

export interface RowPopoverProps {
  alertMessage?: AlertMessageDTO | null;
}

export const RowPopover: React.FC<RowPopoverProps> = ({ alertMessage }) => {
  const icon = React.useMemo(() => {
    if (!alertMessage) return null;
    if (alertMessage.type === 'danger') return <IconDanger data-test="icon-danger" />;
    if (alertMessage.type === 'warning') return <IconWarning data-test="icon-warning" />;
    if (alertMessage.type === 'success') return <IconCheckmark data-test="icon-success" />;
    return null;
  }, [alertMessage]);

  if (!alertMessage) {
    return null;
  }

  return (
    <TooltipHelp
      content={alertMessage.message}
      title={alertMessage.title}
      placement="right"
      icon={icon}
    />
  );
};
